import React from 'react';
import cn from 'classnames';

import styles from './style.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  isTransparent?: boolean;
  isOutlined?: boolean;
  isShallow?: boolean;
  isWarning?: boolean;
  isLoading?: boolean;
  isLarge?: boolean;
  isSmall?: boolean;
  isWhite?: boolean;
  isFull?: boolean;
  isLink?: boolean;
  isText?: boolean;
  isRadio?: boolean;
}

// We need to forward ref explicitly
// So that we can use tooltips on top of buttons
// In the future our re-usable components will handle this
const Button = React.forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      className = '',
      disabled = false,
      isTransparent = false,
      isOutlined = false,
      isShallow = false,
      isWarning = false,
      isLoading = false,
      isLarge = false,
      isSmall = false,
      isWhite = false,
      isFull = false,
      isLink = false,
      isText = false,
      isRadio = false,
      ...restProps
    },
    ref,
  ) => (
    <button
      ref={ref}
      className={cn(
        styles.button,
        {
          [styles['is-transparent']]: isTransparent,
          [styles['is-outlined']]: isOutlined,
          [styles['is-shallow']]: isShallow,
          [styles['is-warning']]: isWarning,
          [styles['is-loading']]: isLoading,
          [styles['is-large']]: isLarge,
          [styles['is-small']]: isSmall,
          [styles['is-white']]: isWhite,
          [styles['is-full']]: isFull,
          [styles['is-link']]: isLink,
          [styles['is-text']]: isText,
          [styles['is-radio']]: isRadio,
        },
        className,
      )}
      disabled={disabled || isLoading}
      {...restProps}
    >
      {children}
    </button>
  ),
);

export default Button;
